import {toDateTimeString} from '../../utilities/dateUtilities'
export const DisplayDateTime = ({ allowedVrm }) => {
    return (
        <>
            <h6 className="mb-3 fs-1">Date/Time Details</h6>
            <div className="row mb-3">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold m-0">Valid <b>from</b></p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.startDate !== null ? <>{ toDateTimeString(allowedVrm.startDate) }</> : <p className='m-0 text-danger'>No start date</p> }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold m-0">Valid <b>to</b></p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.endDate !== null ? <>{ toDateTimeString(allowedVrm.endDate) }</> : <p className='m-0 text-danger'>No end date</p> }</div>
            </div>
        </>
    )
}